import { EPaymentStatus } from '../../types/payment';

export const PAGE_TYPE = 'LegalCheck';
export const EVENT_CATEGORY = 'LegalCheck';

export const PAYMENT_PAGE_EXTRA_TYPE: Record<EPaymentStatus, string> = {
  [EPaymentStatus.Paid]: 'paymentSuccess',
  [EPaymentStatus.Unpaid]: 'paymentPending',
  [EPaymentStatus.Error]: 'paymentError',
  [EPaymentStatus.Canceled]: 'paymentCanceled',
};
